import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { ITask } from "src/app/data/interfaces/IGoals";

declare global {
  interface Navigator {
    msSaveBlob?: (blob: any, defaultName?: string) => boolean;
  }
}

export const parseJwt = (token: string) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

export const checkNone = (data: any) => {
  return data === undefined || data === null;
};

export const arrayToggle = (arr: number[] | string[], value: any) => {
  const newArr = [...arr];

  if (!newArr.includes(value)) {
    newArr.push(value);
  } else {
    const index = newArr.indexOf(value);
    if (index !== -1) {
      newArr.splice(index, 1);
    }
  }

  return newArr;
};

export const exportHandler = (result: any, fileName: string) => {
  const universalBOM = '\uFEFF';

  const blob = new Blob([result]);
  if (navigator.msSaveBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const a = window.document.createElement('a');
    a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM + result));
    // a.href = window.URL.createObjectURL(blob); not working for utf8
    a.download = fileName;
    document.body.appendChild(a);
    // IE: "Access is denied";
    // see: https://connect.microsoft.com/IE/feedback/details/797361/ie-10-treats-blob-url-as-cross-origin-and-denies-access
    a.click();
    document.body.removeChild(a);
  }
};

export const drop = (event: CdkDragDrop<any[]>) =>{
  if (event.previousContainer === event.container) {
    // Reorder items within the same list
    moveItemInArray(
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  } else {
    // Move items between lists
    transferArrayItem(
      event.previousContainer.data,
      event.container.data,
      event.previousIndex,
      event.currentIndex
    );
  }
}


